import { render, staticRenderFns } from "./PosDept.vue?vue&type=template&id=3503a91a&"
import script from "./PosDept.vue?vue&type=script&lang=js&"
export * from "./PosDept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports